formHelper.addRule({
  form: '#collateral-form',
  status: {
    SUCCESS: function() {
      
      // Show the success header
      $('js-header-normal').hide();
      $('js-header-success').show();


      // Hide some other parts
      $('js-on-success-hide-form-left').hide();
      $('js-on-success-hide-form-right').hide();

    },
    ERROR: function(){

      // Show the hidden error message
    	$('js-form-error').show();

    }
  }

});

formHelper.addRule({
  form: '#email-list-contact-form',
  status: {
    SUCCESS: function() {

      // Hide form
      $('js-on-success-hide-form').hide();
      
      // Show the success header
      $('js-header-normal').hide();
      $('js-header-error').hide();
      $('the-submit-button').hide();
      $('js-header-success').show();

    },
    ERROR: function(){

      // Show the hidden error message
      $('js-header-normal').hide();
      $('js-header-error').show();

    }
  }

});